import { Module } from 'vuex-smart-module';
import CartDetailActions from './actions';
import CartDetailGetters from './getters';
import CartDetailMutations from './mutations';
import CartDetailState from './state';

export default new Module({
  state: CartDetailState,
  mutations: CartDetailMutations,
  actions: CartDetailActions,
  getters: CartDetailGetters,
});
